// Airline color mappings and flight status utilities

export const AIRLINE_COLORS = {
  // Major US Airlines
  UA: { bg: "bg-blue-600", text: "text-blue-600", border: "border-blue-600", light: "bg-blue-50", name: "United Airlines" },
  AA: { bg: "bg-red-600", text: "text-red-600", border: "border-red-600", light: "bg-red-50", name: "American Airlines" },
  DL: { bg: "bg-blue-800", text: "text-blue-800", border: "border-blue-800", light: "bg-blue-50", name: "Delta Air Lines" },
  WN: { bg: "bg-orange-500", text: "text-orange-500", border: "border-orange-500", light: "bg-orange-50", name: "Southwest Airlines" },
  NK: { bg: "bg-yellow-500", text: "text-yellow-900", border: "border-yellow-500", light: "bg-yellow-50", name: "Spirit Airlines" },
  F9: { bg: "bg-green-600", text: "text-green-600", border: "border-green-600", light: "bg-green-50", name: "Frontier Airlines" },
  B6: { bg: "bg-sky-500", text: "text-sky-600", border: "border-sky-500", light: "bg-sky-50", name: "JetBlue Airways" },
  AS: { bg: "bg-teal-600", text: "text-teal-600", border: "border-teal-600", light: "bg-teal-50", name: "Alaska Airlines" },
  
  // International Airlines
  LH: { bg: "bg-yellow-600", text: "text-yellow-700", border: "border-yellow-600", light: "bg-yellow-50", name: "Lufthansa" },
  BA: { bg: "bg-blue-900", text: "text-blue-900", border: "border-blue-900", light: "bg-blue-50", name: "British Airways" },
  AF: { bg: "bg-blue-700", text: "text-blue-700", border: "border-blue-700", light: "bg-blue-50", name: "Air France" },
  EK: { bg: "bg-red-700", text: "text-red-700", border: "border-red-700", light: "bg-red-50", name: "Emirates" },
  QR: { bg: "bg-purple-800", text: "text-purple-800", border: "border-purple-800", light: "bg-purple-50", name: "Qatar Airways" },
  TK: { bg: "bg-red-600", text: "text-red-600", border: "border-red-600", light: "bg-red-50", name: "Turkish Airlines" },
  AC: { bg: "bg-red-600", text: "text-red-600", border: "border-red-600", light: "bg-red-50", name: "Air Canada" },
  AM: { bg: "bg-blue-600", text: "text-blue-600", border: "border-blue-600", light: "bg-blue-50", name: "Aeromexico" },
  
  // Default
  default: { bg: "bg-gray-600", text: "text-gray-600", border: "border-gray-600", light: "bg-gray-50", name: "Airline" }
};

export const getAirlineColors = (airlineCode) => {
  if (!airlineCode) return AIRLINE_COLORS.default;
  const code = airlineCode.toUpperCase().replace(/[0-9]/g, '').trim();
  return AIRLINE_COLORS[code] || AIRLINE_COLORS.default;
};

export const getAirlineCode = (flightNumber) => {
  if (!flightNumber) return '';
  const match = flightNumber.match(/^([A-Za-z]{2})/);
  return match ? match[1].toUpperCase() : '';
};

export const FLIGHT_STATUS = {
  scheduled: { label: "Scheduled", color: "text-blue-600", bg: "bg-blue-100", icon: "clock" },
  active: { label: "In Flight", color: "text-green-600", bg: "bg-green-100", icon: "plane" },
  landed: { label: "Landed", color: "text-green-700", bg: "bg-green-100", icon: "check" },
  cancelled: { label: "Cancelled", color: "text-red-600", bg: "bg-red-100", icon: "x" },
  diverted: { label: "Diverted", color: "text-orange-600", bg: "bg-orange-100", icon: "alert" },
  delayed: { label: "Delayed", color: "text-red-500", bg: "bg-red-100", icon: "clock" },
  "on-time": { label: "On Time", color: "text-green-600", bg: "bg-green-100", icon: "check" },
  unknown: { label: "Unknown", color: "text-gray-600", bg: "bg-gray-100", icon: "help" }
};

export const getFlightStatus = (status, delayed) => {
  if (delayed && delayed > 0) {
    return { 
      ...FLIGHT_STATUS.delayed, 
      label: `Delayed ${delayed} min`,
      isDelayed: true,
      delayMinutes: delayed
    };
  }
  
  const normalizedStatus = status?.toLowerCase() || 'scheduled';
  return FLIGHT_STATUS[normalizedStatus] || FLIGHT_STATUS.unknown;
};

export const formatFlightTime = (isoTime) => {
  if (!isoTime) return '';
  try {
    const date = new Date(isoTime);
    return new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Chicago',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).format(date);
  } catch {
    return isoTime;
  }
};
